namespace Areas.TreeList {
    "use strict";

    const columnChooserButtonName = "columnChooserButton";

    export function addColumnChooser(e: any) {
        const treeList: DevExpress.ui.dxTreeList = e.component;

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: columnChooserButtonName, "class": "dx-datagrid-column-chooser-button" },
            text: "Columns",
            hint: "Choose columns to show/hide",
            type: "normal",
            icon: "column-chooser",
            onClick: showColumnChooser(treeList)
        }, "after");

    }

    function showColumnChooser(treeList: DevExpress.ui.dxTreeList) {
        return (e: any) => {
            treeList.showColumnChooser();
        }
    }

}